export const GET_ALLOCATION_HISTORY_REQUEST = 'GET_ALLOCATION_HISTORY_REQUEST';
export const GET_ALLOCATION_HISTORY_SUCCESS = 'GET_ALLOCATION_HISTORY_SUCCESS';
export const GET_ALLOCATION_HISTORY_FAILURE = 'GET_ALLOCATION_HISTORY_FAILURE';


export const DOWNLOAD_ALLOCATION_FILE_REQUEST = 'DOWNLOAD_ALLOCATION_FILE_REQUEST';
export const DOWNLOAD_ALLOCATION_FILE_SUCCESS = 'DOWNLOAD_ALLOCATION_FILE_SUCCESS';
export const DOWNLOAD_ALLOCATION_FILE_FAILURE = 'DOWNLOAD_ALLOCATION_FILE_FAILURE';

export const UPLOAD_PROPOSAL_REQUEST = 'UPLOAD_PROPOSAL_REQUEST';
export const UPLOAD_PROPOSAL_SUCCESS = 'UPLOAD_PROPOSAL_SUCCESS';
export const UPLOAD_PROPOSAL_FAILURE = 'UPLOAD_PROPOSAL_FAILURE';

export const DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE = 'DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE';
export const DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE_SUCCESS = 'DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE_SUCCESS';
export const DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE_FAILURE = 'DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE_FAILURE';